var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widM padLS padRS padTS padBX",
      staticStyle: {
        border: "3px solid #71020f",
        "background-color": "#fff",
        color: "#2c2c2c"
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("hr", {
        staticClass: "widL marTL marBL",
        staticStyle: { "border-top": "1px solid #e4e4e4" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "amway-theme widXS" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "radio-wrapper marTSM" }, [
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "01", "분당")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("분당")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "02", "강서")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("강서")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "80", "인천")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("인천")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "07", "대전")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("대전")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "48", "청주")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("청주")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "05", "부산")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("부산")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "08", "대구")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("대구")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "49", "창원")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("창원")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "46", "울산")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("울산")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "06", "광주")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("광주")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "41", "전주")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("전주")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "43", "강릉")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("강릉")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "amw-radio-wrap radio-label marLM marRM",
              on: {
                click: function($event) {
                  return _vm.$emit("changelocale", "04", "제주")
                }
              }
            },
            [
              _c("input", {
                staticClass: "amw-global-radio",
                attrs: { type: "radio", name: "local" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-radio-overlay" }),
              _vm._v(" "),
              _c("span", { staticClass: "amw-label-radio-text" }, [
                _vm._v("제주")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "marTS light" }, [
          _c("input", {
            attrs: { id: "remember", type: "checkbox" },
            on: {
              click: function($event) {
                return _vm.$emit("changeagree")
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "normal inline-label checklabel",
              attrs: { for: "remember" }
            },
            [_vm._v("상기 이벤트 내용에 모두 동의합니다.")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "marTM txtC" }, [
          _c(
            "a",
            {
              staticClass: "osResBtn01",
              staticStyle: {
                "background-color": "#71020f",
                width: "70%",
                "max-width": "250px",
                padding: "0.7em 0",
                color: "#fff",
                "border-radius": "2em"
              },
              on: { click: _vm.clickApply }
            },
            [_vm._v("이벤트 신청하기")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", { staticClass: "marTL txtC" }, [
        _c(
          "b",
          {
            staticClass: "disIb",
            staticStyle: {
              "background-color": "#71020f",
              width: "40%",
              "max-width": "150px",
              padding: "0.6em 0",
              color: "#fff",
              "border-radius": "2em"
            }
          },
          [_vm._v("신청 기간")]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "marTM fntH6 txtC bold" }, [
        _vm._v("10월 8일(금) 오전 10시 ~ 10월 11일(월) 자정 "),
        _c("em", { staticClass: "light", staticStyle: { color: "#808285" } }, [
          _vm._v("*한정수량")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", { staticClass: "marTL txtC" }, [
        _c(
          "b",
          {
            staticClass: "disIb",
            staticStyle: {
              "background-color": "#71020f",
              width: "40%",
              "max-width": "150px",
              padding: "0.6em 0",
              color: "#fff",
              "border-radius": "2em"
            }
          },
          [_vm._v("참여 방법")]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "widXS marTM fntH6 bold" }, [
        _c("ol", [
          _c("li", [_vm._v("STEP 1 : 페이지 하단을 통해 이벤트 신청")]),
          _vm._v(" "),
          _c("li", [_vm._v("STEP 2 : 정상 접수 여부 바로 확인")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("STEP 3 : 신청자 앞으로 발송되는 카카오톡 알림톡 확인")
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("STEP 4 : 공병과 함께 ABC 매장 방문하여 샘플 수령")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "marTS txtC", staticStyle: { color: "#808285" } },
          [
            _c("img", {
              staticClass: "icoL",
              attrs: {
                src:
                  "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/item01.jpg",
                alt: "제품 이미지"
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "fntP bold" }, [
              _vm._v("스킨 뉴트리션 퍼밍 울트라 리프팅 크림 미니 "),
              _c("br"),
              _vm._v("(4만원 상당)")
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", { staticClass: "marTL txtC" }, [
        _c(
          "b",
          {
            staticClass: "disIb",
            staticStyle: {
              "background-color": "#71020f",
              width: "40%",
              "max-width": "150px",
              padding: "0.6em 0",
              color: "#fff",
              "border-radius": "2em"
            }
          },
          [_vm._v("수령 기간")]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "marTM fntH6 txtC bold" }, [
        _vm._v("10월 15일(금) ~ 10월 22일(금)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", { staticClass: "marTL txtC" }, [
        _c(
          "b",
          {
            staticClass: "disIb",
            staticStyle: {
              "background-color": "#71020f",
              width: "40%",
              "max-width": "150px",
              padding: "0.6em 0",
              color: "#fff",
              "border-radius": "2em"
            }
          },
          [_vm._v("공병 기준")]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "widXS marTSM fntP bold" }, [
        _c("p", [_vm._v("수거 공병의 기준을 반드시 유의하시기 바랍니다.")]),
        _vm._v(" "),
        _c("ul", { staticClass: "padTS" }, [
          _c("li", { staticClass: "marTS" }, [
            _c("b", [
              _c("img", {
                staticStyle: { height: "1em" },
                attrs: {
                  src:
                    "https://www.amway.co.kr/_ui/_noticeImg/2021/02/0204_artnutri/bull_01.png",
                  alt: ""
                }
              }),
              _vm._v(" 수거 공병 리스트")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "osResNoticeList padLM" }, [
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "- 아티스트리 유스 익스텐드 라인 제품 공병 : 113800V, 113801V, 113802V, 113810V, 113806V, 113808V"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- 아티스트리 유스 익스텐드 울트라 라인 제품 공병 : 117018V, 117016V"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- 아티스트리 스킨 뉴트리션 밸런싱 라인 제품 공병 : 123792J, 123797J, 123794J"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- 아티스트리 스킨 뉴트리션 하이드레이팅 라인 제품 공병 : 123793J, 123795J, 123796J, 123798J"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("- 아티스트리 스킨 뉴트리션 클렌징류 : 123791J")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "marTS" }, [
            _c("b", [
              _c("img", {
                staticStyle: { height: "1em" },
                attrs: {
                  src:
                    "https://www.amway.co.kr/_ui/_noticeImg/2021/02/0204_artnutri/bull_01.png",
                  alt: ""
                }
              }),
              _vm._v(" 제외 대상")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "osResNoticeList padLM" }, [
              _c("ul", [
                _c("li", [
                  _vm._v("- 상기에 명시된 기준 외 아티스트리 제품 공병")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("- 증정용 샘플 공병")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS",
              staticStyle: { "padding-left": "0.5em", "text-indent": "-0.5em" }
            },
            [
              _vm._v(
                "*선물세트 구성품의 미니 샘플, 박스는 공병으로 인정되지 않습니다."
              )
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", { staticClass: "marTL txtC" }, [
        _c(
          "b",
          {
            staticClass: "disIb",
            staticStyle: {
              "background-color": "#71020f",
              width: "40%",
              "max-width": "150px",
              padding: "0.6em 0",
              color: "#fff",
              "border-radius": "2em"
            }
          },
          [_vm._v("유의 사항")]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "marTSM fntP widXS" }, [
        _c("div", { staticClass: "osResNoticeList" }, [
          _c("ul", [
            _c("li", [
              _vm._v("- 본 이벤트는 한정 수량으로 조기 종료될 수 있습니다.")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("- ABO ID당 총 1회 참여가 가능합니다.")]),
            _vm._v(" "),
            _c("li", [_vm._v("- 대리 수령이 불가합니다.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("- 이벤트 정상 접수 여부를 반드시 확인하시기 바랍니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 신청한 ABC에서만 교환이 가능하며, 변경 처리는 어렵습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 기준에 부합하지 않은 공병으로는 샘플 교환 처리가 어렵기 때문에 공병 기준에 대해 숙지 부탁 드립니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 본 이벤트에 참가하신 분들 중 이벤트에 선정되신 분들에게 공병 교환 관련 알림톡이 발송됩니다. (순차 발송)"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 본 알림톡을 지정하신 ABC에서 교환 시 공병과 함께 지참하여 주십시오."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 알림톡은 주사업자 앞으로 등록된 전화 번호로 전송되기 때문에 이벤트 신청에 앞서 전화 번호 확인을 부탁 드립니다."
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _c("strong", [_vm._v("방문할 ABC 매장을 선택 해 주세요.(변경 불가)")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e665ba4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e665ba4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/waste-glass-bottle2/component/apply.vue
// module id = null
// module chunks = 